"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _Input = _interopRequireDefault(require("../Input"));
var _CurrencyInsetElement = require("./CurrencyInsetElement");
var _constants = require("./constants");
var _propTypes = require("./propTypes");
var _utils2 = require("./utils");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CurrencyInput = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    code,
    locale,
    value,
    onChange,
    defaultValue,
    disabled,
    id,
    ...forwardedProps
  } = _ref;
  const [stateValue, setStateValue] = (0, _react.useState)((0, _utils2.formatToCurrency)(value || defaultValue, locale));

  // The value prop takes priority over the internal state value
  (0, _react.useMemo)(() => {
    if (value !== undefined && value !== stateValue) {
      setStateValue((0, _utils2.formatToCurrency)(value, locale));
    }
  }, [value, locale, stateValue]);
  const handleChange = e => {
    const oldValue = e.target.value;
    const formattedValue = (0, _utils2.formatToCurrency)(oldValue, locale);

    // Manage caret position
    if (stateValue) {
      const element = e.target;
      let caret = element.selectionStart;
      const separatorLengthDifference = formattedValue.replace(/[0-9]/g, '').length - stateValue.replace(/[0-9]/g, '').length;
      const numberLengthDifference = (0, _utils2.stripNonNumericChars)(formattedValue).length - (0, _utils2.stripNonNumericChars)(stateValue).length;

      // Shift caret forwards when a separator is inserted
      // to keep it in the same position.
      // Do that for any difference > 0 to support copy and pasting
      if (separatorLengthDifference > 0) {
        caret += separatorLengthDifference;
      }

      // Shift caret backwards by one when a separator is removed
      // Checks for number length difference to support deleting multiple chars
      // Checks for caret !== 0 to avoid wrapping
      if (separatorLengthDifference === -1 && numberLengthDifference === -1 && caret !== 0) {
        caret -= 1;
      }

      // If the value didn't change, leave the caret in the initial place
      // This can happen when user tries to insert an invalid character
      // Check for length difference to not reset when chars are removed
      if (stateValue === formattedValue && oldValue.length > formattedValue.length) {
        caret = element.selectionStart - 1;
      }
      window.requestAnimationFrame(() => {
        element.selectionStart = caret;
        element.selectionEnd = caret;
      });
    }

    // Only set internal value when the value prop is not passed
    // as the prop takes priority
    value === undefined && setStateValue(formattedValue);
    if (!!onChange && stateValue !== formattedValue) {
      onChange(e, formattedValue, parseInt((0, _utils2.stripNonNumericChars)(formattedValue)));
    }
  };
  const leadingConfig = {
    inset: disabled ? 12 : 0,
    width: _constants.CURRENCY_CODE_CONTAINER_WIDTH + 8,
    element: (0, _react2.jsx)(_CurrencyInsetElement.CurrencyInsetElement, (0, _extends2.default)({}, (0, _utils.omitDataProps)(forwardedProps), {
      disabled: disabled
    }), code)
  };
  return (0, _react2.jsx)(_Input.default, (0, _extends2.default)({}, forwardedProps, {
    id: id,
    insetElementLeading: leadingConfig,
    value: stateValue,
    onChange: handleChange,
    disabled: disabled,
    ref: ref
  }));
});
var _default = exports.default = (0, _utils.composeStencilComponent)({
  baseComponent: CurrencyInput,
  description: 'Input element that automatically formats numbers as a currency.',
  displayName: 'CurrencyInput',
  propTypes: _propTypes.currencyInputPropTypes
});